import * as React from 'react';

import { cn } from '@playbooks/ui/lib/utils';

const AuthFormShell = ({
	as: Component = 'form',
	className = '',
	...props
}: React.ComponentProps<'form'> & { as?: any }) => {
	// Theme
	const rootClassName = cn('relative rounded-media border bg-surface p-5 shadow-sm sm:p-6', className);

	// Render
	return <Component className={rootClassName} {...props} />;
};

export { AuthFormShell };
